<irh-file-upload
	[fileTypeLabel]="fileUploadConfig.fileTypeLabel"
	[fileTypeOptions]="fileUploadConfig.fileTypeOptions"
	[uiMessage]="fileUploadConfig.uiMessage"
	(onUploadFileOutput)="handleUploadFileOutput($event)"
></irh-file-upload>
